module.exports = __webpack_public_path__ + "img/lincoln-red-imps-logo-icon.033edb51.png";